




















import { Component, Prop, Vue } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ActionTypes } from "@/data/enums";
import { defaultTemplate, getFiltersWithOperators } from "@/helpers/table";
import { INewSegmentRouteTypes } from "@/data/enums/segments";

// Types
import { ISegmentTypes } from "@/data/enums/segments";
import { IFilter } from "@/models/tables";

@Component
export default class AddSegmentMessage extends Vue {
  @Prop({ required: true })
  public segmentType!: ISegmentTypes;

  @Prop({ required: true })
  public activeFilters!: IFilter[];

  @Prop({ required: true })
  public preDefinedFilters!: IFilter[];

  @Prop({ required: true })
  public apiProps!: object;

  @Prop({ default: null })
  public newSegmentRedirectRoute!: any;

  public get filter() {
    return getFiltersWithOperators({
      filters: this.$_.concat(this.activeFilters, this.preDefinedFilters),
      template: this.segmentTemplate
    });
  }

  public async openCreateSegmentModal() {
    this.$store.dispatch(
      `data/${DataModules.SEGMENTS}/openManageSegmentModal`,
      {
        props: {
          segmentType: this.segmentType,
          newSegmentRedirectRoute:
            this.newSegmentRedirectRoute || this.redirectRoute,
          actionType: ActionTypes.CREATE,
          filter: getFiltersWithOperators({
            filters: this.$_.concat(this.activeFilters, this.preDefinedFilters),
            template: this.segmentTemplate
          })
        }
      }
    );
  }

  public get redirectRoute() {
    switch (this.segmentType) {
      case ISegmentTypes.CLIENT:
        return INewSegmentRouteTypes.CLIENT;
      case ISegmentTypes.CONTRACTS_PRODUCTS:
        return INewSegmentRouteTypes.CONTRACTS_PRODUCTS;
      case ISegmentTypes.CONTRACTS_PRODUCTS_SALE:
        return INewSegmentRouteTypes.CONTRACTS_PRODUCTS_SALE;
      case ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION:
        return INewSegmentRouteTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION;
      case ISegmentTypes.ORDER:
        return INewSegmentRouteTypes.ORDER;
      default:
        return INewSegmentRouteTypes.CLIENT;
    }
  }

  public segmentTemplate(filter: any, operator: string) {
    // name|like
    return defaultTemplate(filter, operator, "", ["", ""]);
  }
}
